const KEYS = ["ref", "utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function getAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem("lw_attrib") || "{}");
    const fresh = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) fresh[k] = v;
    });
    const merged = {
      ...stored,
      ...fresh,
      landing_page: stored.landing_page || window.location.pathname + window.location.search,
    };
    sessionStorage.setItem("lw_attrib", JSON.stringify(merged));
    return merged;
  } catch {
    return {};
  }
}

export function attributionPayload() {
  const a = getAttribution();
  return {
    referral_code: a.ref || null,
    utm_source: a.utm_source || null,
    utm_medium: a.utm_medium || null,
    utm_campaign: a.utm_campaign || null,
    utm_content: a.utm_content || null,
    landing_page: a.landing_page || null,
  };
}
